// This page is the Dynamic horizontal scroll view (Red carpet static carousel)
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { Link as RouterLink} from 'react-router-dom';
//Artist section
/*
const imgs = [

  { src: '/images/Artists/LowrahStamina.jpeg', link: 'https://www.youtube.com/watch?v=hd8QA0LcR8I', description1: '"STAMINA" OFFICIAL VIDEOCLIP LOWRAH' , description2: 'Now single "Stamina" out on Youtube' },
  { src: '/images/Artists/DidiFuckboy.jpg', link: 'https://open.spotify.com/intl-it/album/4vWnipqN9sM7VyXS3fYH2n', description1: '"FUCKBOY" OFFICIAL VIDEOCLIP DIDI' , description2: 'Official Videoclip out on Spotify', className: "DidiFuckboy" },
  { src: '/images/Artists/wax.jpeg', description1: 'WAX' , description2: 'Editorial project x Wax'},
  { src: '/images/Artists/PumPum.jpg', link:'https://open.spotify.com/intl-it/track/69eQHdoTenhKE9dJYk4Ss5?si=424add993b6042f3', description1:'"PUM PUM" BY GEORGIA MOS OFFICIAL COVER'},
  { src: '/images/Artists/SimoneBernini.png', link:'https://www.youtube.com/watch?v=v1UIXhBjjAw&list=RDv1UIXhBjjAw&start_radio=1', description1:'SIMONE BERNINI "MEMPHIS" OFFICIAL VIDEOCLIP', description2:'Now single "MEMPHIS" out on Spotify and Youtube'},
  { src: '/images/Artists/Mos.jpeg', link: 'https://www.youtube.com/watch?v=2NR3Q4J6SdI', description1: '"CONFETTI" OFFICIAL VIDEOCLIP GEORGIA MOS' , description2: 'Official Videoclip out on Youtube and Spotify' },
  { src: '/images/Artists/DIDI_AmoreEstate.jpg', link: 'https://www.youtube.com/watch?v=i72DMT_gGeA', description1: '"L\'AMORE D\'ESTATE" OFFICIAL VIDEOCLIP DIDI' , description2: 'Official Videoclip out on Youtube and Spotify' },
  { src: '/images/Artists/Desperado.jpg', link: 'https://www.youtube.com/watch?v=S1xAHtCmZKs', description1: '"DESPERADO" OFFICIAL VIDEOCLIP CALILION, TURI MONCADA, VALENTINO' , description2: 'Official Videoclip out on Youtube and Spotify' },
 
    // Aggiungi altre immagini e descrizioni se necessario
];*/

const immagini = [
{ type: 'video', src: '/images/RedCarpet/MeganVideo.mov'},
{ type: 'image', src:  '/images/RedCarpet/elisa.png'},
{ type: 'image', src:  '/images/RedCarpet/Augustina.jpg'},
{ type: 'image', src:  '/images/RedCarpet/MeganRedCarpet_1.jpeg'},
{ type: 'image', src:  '/images/RedCarpet/MeganRedCarpet_2.jpeg'},
{ type: 'image', src:  '/images/RedCarpet/MeganRedCarpet_3.jpeg'},
{ type: 'image', src:  '/images/RedCarpet/MeganRedCarpet_4.jpeg'},
{ type: 'image', src:  '/images/RedCarpet/MeganRedCarpet_5.jpeg'},
];


function Portfolio() {
  const settings = {
    centerMode: true,
    centerPadding: '10px',
    slidesToShow: 4, // Mostra 3 slide alla volta
    speed: 500,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    adaptiveHeight: false, // ✅ FIX PRINCIPALE
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 2, // Mostra 2 slide alla volta sui dispositivi mobili
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          slidesToShow: 1, // Mostra 1 slide alla volta sui dispositivi più piccoli
        },
      },
      {
        breakpoint: 320,
        settings: {
          arrows: false,
          slidesToShow: 1, // Mostra 1 slide alla volta sui dispositivi più piccoli
        },
      },
    ],
  };
  
const renderSlides = immagini.map((item, index) => (
  <div
    key={index}
    className="carousel-item"
    role="group"
    aria-roledescription="carousel"
    aria-label={`Slide ${index + 1}`}
  >
    <RouterLink to="/redcarpet" className="carousel-link">
      {item.type === 'video' ? (
        <video
          className="trending-img"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src={item.src} type="video/mp4" />
        </video>
      ) : (
        <img
          className="trending-img"
          src={item.src}
          alt={`Slide ${index + 1}`}
          loading="lazy"
        />
      )}

      <div className="carousel-description1">{item.description1}</div>
      <div className="carousel-description2">{item.description2}</div>
    </RouterLink>
  </div>
));


  return (
    <section id="Videoclip">
      <div className="App">
        <h4 className="header">Red Carpet</h4>
        <section className="center slider">
          <Slider {...settings}>{renderSlides}</Slider>
        </section>
      </div>
    </section>
  );
}

export default Portfolio;